import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import WorkProcess from './components/WorkProcess';
import WhyChooseUs from './components/WhyChooseUs';
import JenisSekolah from './components/JenisSekolah';
import Paket from './components/Paket';
import Lokasi from './components/Lokasi';
import Contact from './components/Contact';
import Footer from './components/Footer';

import AOS from 'aos'; // <-- untuk animasi scroll
import 'aos/dist/aos.css'; // <-- css animasinya

function App() {
  useEffect(() => {
    AOS.init({ once: true, duration: 800 });
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <WorkProcess />
        <WhyChooseUs />
        <JenisSekolah />
        <Paket />
        <Lokasi />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
